import FilterV3 from '@components/FilterV3/FilterV3';
import { FilterV3ContextProvider } from '@components/FilterV3/contexts/FilterV3.context';
import ObjectScreen from '@components/v2/layout/ObjectScreen/ObjectScreen';
import { useWorkspacePadding } from '@components/v2/layout/hooks/useWorkspacePadding';
import { Box } from '@mui/material';
import { ActivityFeedDomain } from '../../../../services/modules/activityFeed/activityFeed.types';
import { FilterPreferenceRecognizedLists } from '../../../../services/modules/userContextPreferences/userContextPreferences.types';
import useActivityFeedFilterBar from './hooks/useActivityFeedFilterBar';

interface ActivityFeedFilterBarProps {
  list: FilterPreferenceRecognizedLists;
  domains: ActivityFeedDomain[];
}

const ActivityFeedFilterBar = ({ list, domains }: ActivityFeedFilterBarProps) => {
  const { options, fixedFilters } = useActivityFeedFilterBar({ domains });
  const { padding: workspacePadding } = useWorkspacePadding();

  return (
    <FilterV3ContextProvider options={options}>
      <ObjectScreen.FilterBar>
        <Box sx={{ pr: workspacePadding }}>
          <FilterV3 unifiedBar list={list} options={options} FixedFilters={fixedFilters} />
        </Box>
      </ObjectScreen.FilterBar>
    </FilterV3ContextProvider>
  );
};

export default ActivityFeedFilterBar;
